import React from 'react';
import { cn } from '../lib/cn';

/**
 * Button — Botón con variantes.
 *
 * Variants: primary | outline | ghost | danger
 * Sizes:    sm | md | lg | icon
 */
const VARIANTS = {
    primary:
        'bg-[hsl(var(--brand-light))] text-white hover:bg-[hsl(var(--brand-dark))] active:bg-[hsl(var(--brand-dark))]',
    outline:
        'bg-white border border-slate-300 text-slate-700 hover:border-slate-400 hover:text-slate-900 hover:bg-slate-50',
    ghost:
        'bg-transparent text-slate-700 hover:bg-slate-100 hover:text-slate-900',
    danger:
        'bg-[hsl(var(--danger))] text-white hover:bg-red-700',
};

const SIZES = {
    sm: 'h-8 px-3 text-xs gap-1.5',
    md: 'h-9 px-4 text-sm gap-2',
    lg: 'h-10 px-5 text-sm gap-2',
    icon: 'h-9 w-9 p-0',
};

export const Button = React.forwardRef(({
    variant = 'primary',
    size = 'md',
    className,
    children,
    disabled,
    ...props
}, ref) => (
    <button
        ref={ref}
        disabled={disabled}
        className={cn(
            'inline-flex items-center justify-center font-medium rounded-lg transition-colors',
            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(var(--brand-light))] focus-visible:ring-offset-1',
            'disabled:opacity-50 disabled:cursor-not-allowed',
            VARIANTS[variant],
            SIZES[size],
            className
        )}
        {...props}
    >
        {children}
    </button>
));

Button.displayName = 'Button';
